import React from "react";
import style from "../../Styles/Components/Terms.module.css";

const Terms = ({ title, onClick = ()=>{} }) => (
  <div className={style.container}>
    <span className={style.title}>{title}</span>
    <img 
      src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-more.svg"} className={style.icon} style={{right: 16}}
      onClick={onClick.bind(this)}></img>
  </div>
);

export default Terms;
